<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="svgWidth" :height="svgHeight" viewBox="0 0 13.238 13.5" :class="iconCssClass">
    <g data-id="sammio-icon-download-highlight" transform="translate(1 1)">
      <line data-id="Line_35" data-name="Line 35" y2="8.416" transform="translate(5.619)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <path data-id="Path_8" data-name="Path 8" d="M382.438,131.557l-3.317,3.317-3.353-3.352" transform="translate(-373.485 -126.459)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
      <path data-id="Path_9" data-name="Path 9" d="M373.089,134.935v3.528h11.238v-3.528" transform="translate(-373.089 -126.963)" :fill="svgFill" :stroke="svgStroke" stroke-linecap="round" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'print',
  props: ['iconSize', 'iconFill', 'iconStroke', 'iconCssClass'],
  data() {
    return {
      svgWidth: "13.238",
      svgHeight: "13.5",
      svgFill: "none",
      svgStroke: "#236c6c",
      svgStrokeWidth: "2"
    }
  },
  computed: {
    getSize() {
      if (this.iconSize != undefined && this.iconSize !== "") {
        const multiplier = this.iconSize * 1
        this.svgWidth = this.svgWidth * multiplier
        this.svgHeight = this.svgHeight * multiplier
      }
    },
    getFill() {
      if (this.iconFill !== undefined && this.iconFill !== "") {
        return this.svgFill = this.iconFill
      }
      return this.svgFill
    },
    getStroke() {
      if (this.iconStroke !== undefined && this.iconStroke !== "") {
        this.svgStroke = this.iconStroke
      }
      return this.svgStroke
    }
  },
  mounted() {
    this.getSize
  }
}
</script>
